"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COST_PRECISION = void 0;
exports.roundCost = roundCost;
const big_js_1 = __importDefault(require("big.js"));
exports.COST_PRECISION = 2;
function roundCost(cost) {
    const withoutVAT = (0, big_js_1.default)(cost.withoutVAT).toFixed(exports.COST_PRECISION);
    const withVAT = (0, big_js_1.default)(cost.withVAT).toFixed(exports.COST_PRECISION);
    return {
        withoutVAT,
        withVAT,
        vAT: (0, big_js_1.default)(withVAT).minus(withoutVAT).toFixed(exports.COST_PRECISION),
        vATRate: cost.vATRate
    };
}
